import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconLanguageStyle0 = cosmosIconCss;

const CosmosIconLanguage$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLanguage extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'deddd3055124bb5184df259cc5bb0ee4e7d18bbe', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '59f41fdfe462d097dff02dc8f9e1b3b5f26b7d66', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '25e7e9051d917c2eea6e4b7454bf5c47e0e73da4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2.5a8.5 8.5 0 1 0 8.5 8.5A8.51 8.51 0 0 0 11 2.5ZM17.31 8H14.4a13.11 13.11 0 0 0-1.51-3.73A7 7 0 0 1 17.31 8Zm-4.06 3a12.333 12.333 0 0 1-.1 1.5h-4.3a10.28 10.28 0 0 1 0-3h4.29c.072.497.109.998.11 1.5Zm-4.11 3h3.71A11.641 11.641 0 0 1 11 17.91 11.66 11.66 0 0 1 9.14 14Zm0-6A11.76 11.76 0 0 1 11 4.09 11.93 11.93 0 0 1 12.85 8H9.14Zm0-3.73A13.4 13.4 0 0 0 7.59 8H4.68A7 7 0 0 1 9.1 4.27h.04ZM4 11a6.7 6.7 0 0 1 .17-1.5h3.17a12.32 12.32 0 0 0-.1 1.5c.003.502.036 1.002.1 1.5H4.17A6.69 6.69 0 0 1 4 11Zm.68 3h2.91c.31 1.313.82 2.57 1.51 3.73A7 7 0 0 1 4.68 14Zm8.22 3.73A13.201 13.201 0 0 0 14.4 14h2.91a7 7 0 0 1-4.41 3.73Zm1.76-5.23c.056-.498.085-.999.09-1.5a12.333 12.333 0 0 0-.1-1.5h3.18a6.699 6.699 0 0 1 0 3h-3.17Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconLanguageStyle0; }
}, [1, "cosmos-icon-language", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-language"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-language":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLanguage$1);
            }
            break;
    } });
}

const CosmosIconLanguage = CosmosIconLanguage$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLanguage, defineCustomElement };
